import type { ChargeResult, CreateIntentRequest, CreateIntentResult } from "./types";

export const PAYPAL_CHECKOUT_CREATE_INTENT_PATH = "/api/payments/create-intent";
export const PAYPAL_CHECKOUT_CHARGE_RESULT_PATH = "/api/payments/charge-result";

function truncateResponsePreview(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) {
    return "";
  }
  return trimmed.length <= 160 ? trimmed : `${trimmed.slice(0, 160)}...`;
}

async function parsePaymentResponse<T extends { success: boolean; code?: string; message?: string }>(
  res: Response
): Promise<T> {
  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const isJson = contentType.includes("application/json");

  if (isJson) {
    return (await res.json()) as T;
  }

  const body = await res.text().catch(() => "");
  const bodyPreview = truncateResponsePreview(body);
  const statusInfo = `HTTP ${res.status}`;
  const message = bodyPreview
    ? `Payment API returned non-JSON (${statusInfo}): ${bodyPreview}`
    : `Payment API returned non-JSON (${statusInfo})`;

  return {
    success: false,
    code: "invalid_response",
    message,
  } as T;
}

export async function paypalCheckoutCreateIntent(request: CreateIntentRequest): Promise<CreateIntentResult> {
  const res = await fetch(PAYPAL_CHECKOUT_CREATE_INTENT_PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(request),
  });
  return await parsePaymentResponse<CreateIntentResult>(res);
}

export async function paypalCheckoutChargeResult(intentId: string): Promise<ChargeResult> {
  const res = await fetch(PAYPAL_CHECKOUT_CHARGE_RESULT_PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ intentId }),
  });
  return await parsePaymentResponse<ChargeResult>(res);
}
